import React from 'react';
import { SetURLSearchParams } from 'react-router-dom';
import TriggerTypeFilter from './TriggerTypeFilter';
import TextInput from '../../../../components/UI/TextInput';
import styles from '../EvaluationsPage.module.scss';

interface Props {
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
}

const EvaluationsFilters: React.FC<Props> = ({ searchParams, setSearchParams }) => {
  const handleTriggerTypeChange = (value: string | undefined) => {
    if (value) {
      searchParams.set('trigger_type', value);
    } else {
      searchParams.delete('trigger_type');
    }
    searchParams.delete('page');
    setSearchParams(searchParams);
  };

  const handleTriggerIdChange = (value: string) => {
    if (value) {
      searchParams.set('trigger_id', value);
    } else {
      searchParams.delete('trigger_id');
    }
    searchParams.delete('page');
    setSearchParams(searchParams);
  };

  return (
    <div className={styles.filters}>
      <TriggerTypeFilter
        value={searchParams.get('trigger_type') || ''}
        onChange={handleTriggerTypeChange}
      />
      <TextInput
        label="Trigger ID"
        value={searchParams.get('trigger_id') || ''}
        onChange={handleTriggerIdChange}
        placeholder="Enter trigger ID"
      />
    </div>
  );
};

export default EvaluationsFilters;
